interface IsAdminEntityUnavailableOptions<TData> {
  data: TData | null | undefined
  error: unknown
  /** Numeric model ids, or string ids (e.g. credentials). Callers normalize invalid ids to undefined. */
  id: number | string | undefined
  isFetched: boolean
  isUnavailableError: (error: unknown) => boolean
}

/**
 * Shared unavailable check for admin entity show/edit pages (invalid id,
 * fetched-empty, or expected 403/404).
 */
export const isAdminEntityUnavailable = <TData>({
  data,
  error,
  id,
  isFetched,
  isUnavailableError,
}: IsAdminEntityUnavailableOptions<TData>): boolean =>
  id === undefined || (isFetched && (data == null || isUnavailableError(error)))
